// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#vue-editor-wrapper{min-height:42px;max-height:150px;overflow-y:auto}.slim #vue-editor-wrapper{min-height:30px;max-height:30px;overflow-y:hidden;padding:6px 4px 5px 10px!important}", ""]);
// Exports
module.exports = exports;
